import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=877c0dc0&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SidebarHeader: require('/app/components/admin/Sidebar/SidebarHeader.vue').default,SidebarForm: require('/app/components/admin/Sidebar/SidebarForm.vue').default,SidebarNavTitle: require('/app/components/admin/Sidebar/SidebarNavTitle.vue').default,SidebarNavDivider: require('/app/components/admin/Sidebar/SidebarNavDivider.vue').default,SidebarNavLabel: require('/app/components/admin/Sidebar/SidebarNavLabel.vue').default,SidebarNavLink: require('/app/components/admin/Sidebar/SidebarNavLink.vue').default,SidebarNavDropdown: require('/app/components/admin/Sidebar/SidebarNavDropdown.vue').default,SidebarNavItem: require('/app/components/admin/Sidebar/SidebarNavItem.vue').default,SidebarFooter: require('/app/components/admin/Sidebar/SidebarFooter.vue').default,SidebarMinimizer: require('/app/components/admin/Sidebar/SidebarMinimizer.vue').default})
